import { createFileRoute } from "@tanstack/react-router";

import Main from "~/pages/Main";
import { ROUTE_STATIC } from "~/utils/routeStaticData";

export const Route = createFileRoute("/_private/main")({
  staticData: ROUTE_STATIC.main,
  component: Main,
});
